<app-dynamic-table [schema]="schema" [modalfieldConfig]="fieldConfig" [total]="total" [data]="list"
    (changeEvent)="change($event)" ></app-dynamic-table>
